import { styled } from '@linaria/react';
import { useTranslation } from 'react-i18next';
import { useGlobalStore } from '../../../../../store/global-store/global-store';
import {
  baseWhite,
  fontFamily,
  fontSizeSmall,
  fontWeightBold,
  inkDarker,
  skyLight,
} from '../../../../../styles/design-tokens';
import { EntityDropdown } from './entity-dropdown';

type Props = {
  entityNames: Record<string, string>;
  entityIds: string[];
  selectedEntities: string[];
  setSelectedEntities: (entityIds: string[]) => void;
};

export const TableHeader = ({ entityNames, entityIds, selectedEntities, setSelectedEntities }: Props) => {
  const i18n = useTranslation();
  const globalPortfolio = useGlobalStore((state) => state.portfolio);

  return (
    <HeaderRow>
      <HeaderCell>
        <HeaderContent>
          <HeaderText>{i18n.t('common.measures')}</HeaderText>
        </HeaderContent>
      </HeaderCell>

      {entityIds.map((entityId) => (
        <HeaderCell key={entityId}>
          <HeaderContent>
            {entityId === globalPortfolio?.id ? (
              <HeaderText>{globalPortfolio.name}</HeaderText>
            ) : (
              <EntityDropdown
                currentEntityId={entityId}
                currentEntityName={entityNames[entityId] || entityId}
                selectedEntities={selectedEntities}
                setSelectedEntities={setSelectedEntities}
              />
            )}
          </HeaderContent>
        </HeaderCell>
      ))}
    </HeaderRow>
  );
};

const HeaderRow = styled.div`
  display: flex;
  background-color: ${baseWhite};
`;

const HeaderCell = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 16px 12px 30px;
  border: 1px solid ${skyLight};
  border-bottom: 1px solid ${skyLight};
  flex: 1 1 0;
  min-width: 0;
  gap: 10px;
  
  &:first-child {
    border-left: 1px solid ${skyLight};
  }
  
  &:not(:first-child) {
    border-left: none;
  }
  
  &:last-child {
    border-right: 1px solid ${skyLight};
  }
`;

const HeaderContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 10px;
`;

const HeaderText = styled.span`
  font-family: ${fontFamily}, sans-serif;
  font-weight: ${fontWeightBold};
  font-size: ${fontSizeSmall};
  line-height: 1em;
  color: ${inkDarker};
  text-align: left;
`;
